import { useIntl } from '@weenat/wintl';
import { enums } from '../..';
function useDeviceOrigin(device) {
    const { t } = useIntl();
    const { origin, originName } = device;
    const isFromCurrentOrg = origin === enums.Devices.Origin.fromOwnOrganization;
    const isFromNetwork = origin === enums.Devices.Origin.fromNetwork || origin === enums.Devices.Origin.fromAdherentFarm;
    const isFromASubscribingAdherentFarm = origin === enums.Devices.Origin.fromASubscribingAdherentFarm;
    const label = isFromCurrentOrg ? t('roles.owner', { capitalize: true }) : originName;
    const simplifiedOrigin = isFromCurrentOrg
        ? 'currentOrg'
        : isFromNetwork
            ? 'network'
            : isFromASubscribingAdherentFarm
                ? 'adherentFarm'
                : null;
    return { label, simplifiedOrigin };
}
export default useDeviceOrigin;
